import styled from 'styled-components'

export const StyledTable = styled.table`
  background-color: ${({ theme }) => theme.bg3};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smaller};
  display: table;
  width: 100%;
`

export const THead = styled.thead`
  background-color: ${({ theme }) => theme.bg3};
  position: sticky;
  top: 0;
  z-index: 3;
`

export const TableHeader = styled.th`
  background-color: ${({ theme }) => theme.bg3};
  font-weight: 500;
  padding: 1.5rem 1rem;
  text-align: right;
  white-space: nowrap;
`

export const TBody = styled.tbody``
export const TableRow = styled.tr``

export const TableItem = styled.td`
  background-color: ${({ theme }) => theme.bg3};
  font-weight: 500;
  padding: 0.5rem 1rem;
  text-align: right;

  & * {
    font-weight: 500;
  }
`

export const TableItemColor = styled(TableItem)<{ isIncreasing: boolean }>`
  color: ${({ theme, isIncreasing }) => (isIncreasing ? theme.green2 : theme.red4)};
`

export const TableItemSticky = styled(TableItem)`
  left: 0;
  position: sticky;
  text-align: left;
  text-overflow: hidden;
  white-space: nowrap;
  z-index: 2;
`

export const LoaderWrapper = styled.div`
  padding: 1rem;
  text-align: center;
`
